import { useNavigate } from "react-router-dom";

function shouldHandleLink(href) {
  return href && href.startsWith("/") && !href.startsWith("//");
}

function StaticHtmlPage({ html }) {
  const navigate = useNavigate();

  function handleClick(event) {
    const link = event.target.closest("a[href]");

    if (!link) {
      return;
    }

    const href = link.getAttribute("href");

    if (!shouldHandleLink(href)) {
      return;
    }

    event.preventDefault();
    navigate(href);
  }

  function handleSubmit(event) {
    const form = event.target;

    if (form.matches("form")) {
      event.preventDefault();
    }
  }

  return <div className="static-html-page" onClick={handleClick} onSubmit={handleSubmit} dangerouslySetInnerHTML={{ __html: html }} />;
}

export default StaticHtmlPage;
